<template>
  <div class="container lms-wrapper no-right-sidebar">
    <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <div class="card">
          <div class="card-body">
            <student-nav @route-changed="toggleNavbar(false)" />
          </div>
        </div>
      </div>
    </div>

    <div
      class="lms-content"
      @click="navbarMode == 1 ? toggleNavbar(false) : ''"
    >
      <div class="lms-content-body">
        <!-- <vc-calendar
      class="custom-calendar max-w-full"
      :masks="masks"
      :attributes="attributes"
      disable-page-swipe
      is-expanded
    >
      <template v-slot:day-content="{ day, attributes }">
        <div class="flex flex-col h-full z-10 overflow-hidden">
          <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
          <div class="flex-grow overflow-y-auto overflow-x-auto">
            <p
              v-for="attr in attributes"
              :key="attr.key"
              class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
              :class="attr.customData.class"
            >
              {{ attr.customData.title }}
            </p>
          </div>
        </div>
      </template>
        </vc-calendar>-->
        <div class="calendar-content" style="left: 0">
          <FullCalendar
            :options="calendarOptions"
            class="calendar-content-body"
          />
        </div>
      </div>
      <b-modal
        v-model="showModal"
        @hide="cancel()"
        hide-footer
        hide-header
        centered
        body-class="pd-0"
      >
        <div class="calendar-modal-event">
          <div :class="`modal-header bg-${current.color}`">
            <h6 class="event-title">{{ current.title }}</h6>
            <nav class="nav nav-modal-event">
              <!-- <a class="nav-link">
                <feather type="link"></feather>
              </a>-->
              <a class="nav-link" @click="cancel()" role="button">
                <feather type="x"></feather>
              </a>
            </nav>
          </div>

          <div v-if="showModal" class="modal-body">
            <div class="row row-sm">
              <div class="col-sm-6">
                <label
                  class="tx-uppercase tx-sans tx-11 tx-medium tx-spacing-1 tx-color-03"
                  >Эхлэх</label
                >
                <p class="event-start-date">
                  {{ current.startDate | moment("YYYY.MM.DD HH:mm dddd") }}
                </p>
              </div>
              <div class="col-sm-6">
                <label
                  class="tx-uppercase tx-sans tx-11 tx-medium tx-spacing-1 tx-color-03"
                  >Дуусах</label
                >
                <p class="event-end-date">
                  {{ current.endDate | moment("YYYY.MM.DD HH:mm dddd") }}
                </p>
              </div>
              <!-- col-6 -->
            </div>
            <!-- row -->

            <label
              class="tx-uppercase tx-sans tx-11 tx-medium tx-spacing-1 tx-color-03"
              >Дэлгэрэнгүй</label
            >
            <p class="event-desc tx-gray-900">{{ current.title }}</p>
            <p class="event-desc tx-gray-900 mg-b-40">
              {{ current.course.name }}
            </p>

            <!-- <div class="d-flex">
              <a class="btn btn-secondary pd-x-20" @click="cancel()">Хаах</a>
              <a class="btn btn-primary pd-x-20" >Дэлгэрэнгүй</a>
            </div>-->
          </div>
          <div v-if="showModal" class="modal-footer pd-x-20 pd-y-15">
            <button type="button" class="btn btn-white" @click="cancel()">
              Хаах
            </button>
            <router-link
              v-if="current.hasLink"
              :to="current.rawUrl"
              type="button"
              class="btn btn-primary"
              >Дэлгэрэнгүй</router-link
            >
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
//import interactionPlugin from '@fullcalendar/interaction'
import { request } from "@/api/all";

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    studentNav: () => ({
      component: import("@/views/modules/lms/teacher/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    const month = new Date().getMonth();
    const year = new Date().getFullYear();

    return {
      calendarOptions: {
        headerToolbar: {
          left: "prev,next,today",
          center: "title",
          right: "dayGridMonth,dayGridWeek,dayGridDay"
        },
        plugins: [
          dayGridPlugin //, interactionPlugin
        ],
        initialView: "dayGridMonth",
        dateClick: this.handleDateClick,
        events: [
          // { id: "guid-1", title: "event 1", date: "2021-04-08" },
          // { id: "guid-2", title: "event 2", date: "2021-04-12" }
        ],
        eventClick: this.showInfoModal
      },

      navbarMode: 0,

      masks: {
        weekdays: "WWW"
      },
      attributes: [
        {
          key: 1,
          customData: {
            title: "Lunch with mom.",
            class: "bg-red-600 text-white"
          },
          dates: new Date(year, month, 1)
        }
      ],
      calendarData: [],
      showModal: false,
      current: {}
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/scss/pages/calendar.scss");
    require("@/assets/css/dynamic.lms.css");
    this.fetchData();
  },

  destroyed() {
    this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    fetchData() {
      request({
        api: { method: "get", url: "v2/Learn/GetStudentCalendarData" },
        params: { year: 0, month: 0 },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.calendarData = res.data.list;
          this.init();
        }
      });
    },
    init() {
      this.calendarOptions.events = this.calendarData.map(e => {
        return {
          id: e.id,
          title: e.title,
          date: e.calendarDate,
          start: e.startDate,
          end: e.endDate
        };
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    showInfoModal(e) {
      let filtered = this.calendarData.filter(x => x.id == e.event.id);
      if (filtered.length > 0) {
        this.showModal = true;
        this.current = filtered[0];
      }
    },
    cancel() {
      this.showModal = false;
    }
  }
};
</script>
